import { render } from "./ProgramVideo.vue?vue&type=template&id=1ba0b584&scoped=true"
import script from "./ProgramVideo.vue?vue&type=script&lang=js"
export * from "./ProgramVideo.vue?vue&type=script&lang=js"

import "./ProgramVideo.vue?vue&type=style&index=0&id=1ba0b584&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ba0b584"]])

export default __exports__
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QSpinner,QCard,QCardSection});
